










import AdminViolation from '@/components/Admin/AdminViolation.vue';
import {Prop, Emit, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from '@/components/Admin/AdminNavBar.vue';
import Component, {mixins} from 'vue-class-component';
import AdminUsers from '@/components/Admin/AdminUsers.vue';
import AdminReviews from '@/components/Admin/AdminReviews.vue';
import AdminComments from '@/components/Admin/AdminComments.vue';
import Reporting from '@/components/Admin/Reporting.vue';

@Component({
  components: {
    AdminNavBar,
    AdminViolation,
    AdminReviews,
    AdminUsers,
    AdminComments,
    Reporting,
  },
})
export default class Admin extends Vue {
  @Prop(String) public readonly route!: string;
  }
